import React, { useEffect, useState, useRef, useReducer, FC } from "react";
import { Row, Col, Input, Button, Popover, Switch } from "antd";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
// import { InfoBox } from "react-google-maps/lib/components/addons/InfoBox";
import Geocode from "react-geocode";
import { ReloadOutlined } from "@ant-design/icons";
import FilterIcon from "assets/SVGs/FilterIcon";
import SettingsIcon from "assets/SVGs/SettingsIcon";
// import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import Map from "./Map";
import { RootState } from "reducers/rootReducer";
import MapService from "./MapService";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import { getRespondersRequestPublishTopic, getAssetsRequestPublishTopic } from "hooks/MQTTConstants";
import { useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import { pushNotification } from "utils/notifications";

const DEFAULT_LOCATION = { lat: 51.509865, lng: -0.118092 };
/*global google*/

function useMounted() {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted;
}

const MapPanel: FC<{ socket: ISocket; params: any }> = ({ socket, params }) => {
  const { screens, setScreens } = params;
  const [activePop, setActivePop] = useState<string>();
  const [currentLocation, setCurrentLocation] = useState<any>();
  const [active, setActive] = useState<boolean>(true);
  const [showMap, setShowMap] = useState<boolean>(true);
  const [markers, setMarkers] = useState<any[]>([]);
  const [assetMarkers, setAssetMarkers] = useState<any[]>([]);
  const [currentMarkers, setCurrentMarkers] = useState<any[]>([]);
  const [panel, setPanel] = useState<boolean>(false);
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  const { responders, incidentLocation, project, otherLocations, assets, geofenceLocation, standLocations, encrypted_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { search } = useLocation();
  const [mapBounds, setBounds] = useState<any>();
  const dispatch = useDispatch();
  const isMounted = useMounted();
  const { createPlaceMarker, createCurrentMarker, createAssetMarker } = MapService();
  const [searching, setSearching] = useState<boolean>(false);
  const [polygon, setPolygon] = useState<any>(undefined);
  const [circle, setCircle] = useState<any>(undefined);
  const [stands, setStands] = useState<any>([]);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const lat = query.get("lat");
    const lng = query.get("lng");
    if(lat && lng){
      setCurrentLocation({
        lat: parseFloat(lat),
        lng: parseFloat(lng),
        current: true,
      });
    }
    else{
      getMyLocationHandler();
    }
  }, [search]);

  useEffect(() => {
    if (otherLocations) {
      console.log('other locations', otherLocations);
      const otherMarkers = Object.keys(otherLocations).map((key) => {
        return createCurrentMarker(otherLocations[key]);
      });
      setCurrentMarkers(otherMarkers);
    }
  }, [otherLocations]);

  useEffect(() => {
    if (geofenceLocation) {
      console.log('geofence location', geofenceLocation);
      if(geofenceLocation?.location.type === 'Polygon'){
        const paths =  geofenceLocation?.location.coordinates.map((coordinate) => {
          return { lat: coordinate?.[1], lng: coordinate?.[0] };
        });
        setPolygon({paths})
      }
      else{
        setCircle(geofenceLocation)
      }
    }
    else{
      setPolygon(undefined)
      setCircle(undefined);
    }
  }, [geofenceLocation]);

  useEffect(() => {
    if (standLocations) {
      console.log('stand locations', standLocations);
      setStands(standLocations)
    }
  }, [standLocations]);

  const getResponders = (latLng: any, height: number, width: number) => {
    // const query = new URLSearchParams(search);
    // const userId = query.get("userId");
    // const connectionId = query.get("connectionId");

    // 321951

    setSearching(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getRespondersRequestPublishTopic(encrypted_token?.connectionId),
      wrapRequestPayload({
        userId: encrypted_token?.userId,
        projectId: project,
        latLng,
        height: 300000,
        width: 300000,
      })
    );
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getAssetsRequestPublishTopic(connectionId),
    //   wrapRequestPayload({
    //     userId,
    //     projectId: project,
    //     latLng,
    //     height,
    //     width,
    //   })
    // );
  };

  // useEffect(() => {
  //   if (incidentLocation) {
  //     setCurrentLocation({
  //       lat: incidentLocation?.value?.coordinates?.lat,
  //       lng: incidentLocation?.value?.coordinates?.long,
  //     });
  //   }
  // }, [incidentLocation]);

  useEffect(() => {
    if (project && mapBounds) {
      const { latLong, height, width } = mapBounds;
      // getResponders(latLong, height, width);
    }
  }, [project]);

  // useEffect(() => {
  //   if (project && bounds) {
  //     // const { latLong, height, width } = bounds;
  //     // getResponders(latLong, height, width);
  //     console.log('bounds here')
  //   }
  // }, [bounds]);

  useEffect(() => {
    setSearching(false);
    if (responders) {
      console.log('responders', responders);
      let markers = responders.map((responder) => {
        return createPlaceMarker(responder);
      });
      markers = markers.filter((marker)=>{
        return (marker.lat !== undefined && marker.lng !== undefined)
      })
      // if(markers.length === 0){
      //   pushNotification("No Responder available in the area", 'error', 'TOP_CENTER', 1000)
  
      // }
      console.log('markers here', markers)
      setMarkers(markers);
    }
  }, [responders]);


  useEffect(() => {
    setSearching(false);
    if (assets && assets.length > 0) {
      console.log('assets here', assets)
      let markers = assets.map((asset) => {
        return createAssetMarker(asset);
      });
      markers = markers.filter((marker)=>{
        return (marker.lat !== undefined && marker.lng !== undefined)
      });
      setAssetMarkers(markers);
    }
  }, [assets]);

  const getMyLocationHandler = () => {
    if (currentLocation && currentLocation?.current) {
      setCurrentLocation({ ...currentLocation });
      return;
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          lat: position?.coords?.latitude,
          lng: position?.coords?.longitude,
          current: true,
        });
        Geocode.fromLatLng(
          position?.coords?.latitude?.toString(),
          position.coords.longitude?.toString()
        ).then(
          (response) => {
            let city, country;
            for (
              let i = 0, len = response.results[0].address_components.length;
              i < len;
              i++
            ) {
              var ac = response.results[0].address_components[i];
              if (ac.types.indexOf("administrative_area_level_1") >= 0)
                city = ac.short_name;
              if (ac.types.indexOf("country") >= 0) country = ac.short_name;
            }
          },
          (error) => {
            console.error(error);
          }
        );
      });
    } else {
      alert("Geolocation is not supported by this browser.");
      setCurrentLocation(DEFAULT_LOCATION);
    }
  };

  const clearMapHandler = () => {
    setActive(false);
    setPanel(false);
    setMarkers([]);
    setAssetMarkers([]);
  };

  const googleSuggestHandler = (place: any) => {
    geocodeByPlaceId(place.place_id)
      .then((results) => {
        if (results[0].geometry) {
          setCurrentLocation({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
            current: false,
          });
        }
      })
      .catch((error) => console.error(error));
  };

  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d * 1000;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  return (
    <div className="main-column map-panel mr-4">
      <div className="main-content">
        {/* <div className="main-header"> */}
          {/* <div className="d-flex"></div> */}
          {/* <div className="d-flex">
            <ReactSVG
              src="/images/expand-icon.svg"
              className="close-icon mr-4"
              onClick={() =>
                setScreens({
                  ...screens,
                  active: screens.active ? "" : "map",
                })
              }
            />
            <ReactSVG
              src="/images/close-icon.svg"
              className="close-icon"
              onClick={() => setScreens({ ...screens, map: false })}
            />
          </div> */}
        {/* </div> */}
        <div className="search-bar mt-3">
          <div className="d-flex">
            <div className="g-map-search-input">
              <GooglePlacesAutocomplete
                autocompletionRequest={
                  {
                    // bounds: bounds,
                    // componentRestrictions: {
                    //   country: [addressComponent.country],
                    // }
                  }
                }
                selectProps={{
                  onChange: (place: any) => {
                    // console.log('place here', place)
                    if (place) googleSuggestHandler(place.value);
                  },
                  isClearable: true,
                  placeholder: "Search map",
                  styles: {
                    input: (provided: any) => ({
                      ...provided,
                      fontFamily: "Nunito-Regular",
                    }),
                  },
                }}
                apiKey={"AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"}
              />
            </div>
            <Button className="beam-btn ml-2">
              <ReactSVG
                src="/images/location-icon.svg"
                onClick={getMyLocationHandler}
              />
            </Button>
            <Button className="beam-btn ml-2">
              <ReactSVG
                src="/images/reload-icon.svg"
                onClick={() => {
                  clearMapHandler();
                  getMyLocationHandler();
                }}
              />
            </Button>
          </div>
        </div>
        <div className="main-cards">
          <Row className="map-container-layout">
            <Col md={screens.active && panel ? 6 : 0}>
              <div id="direction-panel" />
            </Col>
            <Col md={screens.active && panel ? 18 : 24}>
              {showMap && (
                <Map
                  currentLocation={currentLocation}
                  markers={markers}
                  assetMarkers={assetMarkers}
                  currentMarkers={currentMarkers}
                  polygon={polygon}
                  circle={circle}
                  stands={stands}
                  active={active}
                  setActive={setActive}
                  getPlaces={(resp) => {
                    const { bounds, center } = resp;
                    const height = getDistanceFromLatLonInKm(
                      bounds.minLat,
                      bounds.maxLon,
                      bounds.maxLat,
                      bounds.maxLon
                    );
                    const width = getDistanceFromLatLonInKm(
                      bounds.minLat,
                      bounds.maxLon,
                      bounds.minLat,
                      bounds.minLon
                    );
                    const latLong = {
                      lat: center.lat(),
                      long: center.lng(),
                    };
                    // if (!mapBounds) {
                    //   getResponders(latLong, height, width);
                    // }
                    setBounds({ latLong, height: height, width: width });
                  }}
                />
              )}
            </Col>

            {/* {project && ( */}
              <Row className="lock-icons" onClick={()=>{
                if(searching)return;
                      if (mapBounds) {
                        const { latLong, height, width } = mapBounds;
                        getResponders(latLong, height, width);
                      }
                    }}>
                {searching && (
                  <Col span={2}>
                    <Loader
                      type="TailSpin"
                      color="#fff"
                      height={15}
                      width={15}
                    />
                  </Col>
                )}
                <Col span={22}>
                  Search & select the available driver in the area
                </Col>
                {/* {!searching && (
                  <Col span={2}>
                    <ReloadOutlined onClick={()=>{
                      if (mapBounds) {
                        const { latLong, height, width } = mapBounds;
                        getResponders(latLong, height, width);
                      }
                    }}/>
                  </Col>
                )} */}
              </Row>
            {/* )} */}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default MapPanel;
